import * as Yup from 'yup';

export default () => {
  return Yup.object().shape({
    feeInPence: Yup.number().typeError('Type only numbers'),
  });
};
